import { ReactNode } from 'react'
import { Paragraph, Box, Button, Icon } from '@alto-avios/alto-ui'
import styles from './CollapsibleButton.module.scss'

interface CollapsibleButtonProps {
  title: ReactNode
  content?: ReactNode
  isExpanded: boolean
  setExpanded: (x: boolean) => void
  id?: string
  'aria-controls'?: string
}

function CollapsibleButton({
  title,
  content,
  isExpanded,
  setExpanded,
  id,
  'aria-controls': ariaControls,
}: CollapsibleButtonProps) {
  const handleToggle = () => {
    setExpanded(!isExpanded)
  }
  return (
    <Box margin={0} padding={0} className={styles.container}>
      <Button
        onClick={handleToggle}
        aria-expanded={isExpanded}
        id={id}
        aria-controls={ariaControls}
        fullWidth
        styleVariant="white"
      >
        {title}
        <Box alignItems="center" gap="2xs">
          <Paragraph foregroundColor="accentOnSubtle" size="sm">
            <strong>{content}</strong>
          </Paragraph>
          <Icon iconName={isExpanded ? 'chevron-up' : 'chevron-down'} iconSize="0.75x" />
        </Box>
      </Button>
    </Box>
  )
}
export default CollapsibleButton
